import { render } from "./RuiLogo.vue?vue&type=template&id=ce7ea57e"
const script = {}
script.render = render

export default script